module.exports = __webpack_public_path__ + "img/towers.64d4f87f.svg";